import * as React from "react";
import {
  ImageField,
  TextInput,
  ImageInput,
  BooleanInput,
  Edit,
  FormDataConsumer,
  useRecordContext,
  Title,
  SelectInput,
  NumberInput,
} from "react-admin";
import { SimpleForm } from "../common/SimpleForm";
import { IMAGE_MAX_SIZE } from "../constants/FileConstants";
import { validateOrder, validateRequired } from "../utils/Validations";
import PolygonMapField from "./PolygonMap/PolygonMapField";
import { getCountries } from "../enums/Countries";

const RegionTitle = () => {
  const record = useRecordContext();
  return <Title title={`Región "${record?.name}"`} />;
};

const RegionEdit = () => (
  <Edit title={<RegionTitle />} mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="name" label="Nombre" validate={validateRequired} />
      <ImageInput
        source="image"
        label="Imagen"
        accept={{
          "image/*": [],
        }}
        validate={validateRequired}
        maxSize={IMAGE_MAX_SIZE}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          if (!formData.image.rawFile) {
            return <ImageField source="image" {...rest} />;
          }
        }}
      </FormDataConsumer>
      <PolygonMapField />
      <SelectInput
        label="País"
        source="country"
        choices={getCountries()}
        validate={validateRequired}
      />
      <NumberInput
        source="order"
        label="Orden"
        min={1}
        validate={validateOrder}
        onWheel={(e) => e.target.blur()}
      />
      <BooleanInput source="hasDiscounts" label="Descuentos" />
      <BooleanInput source="visible" label="Visible" />
      <BooleanInput source="active" label="Activo" />
    </SimpleForm>
  </Edit>
);

export default RegionEdit;
